import { FC, ReactNode } from 'react';

export const CustomizableInput: FC<{
  children: ReactNode;
  isCustomized?: boolean;
}> = ({ isCustomized = false, children }) =>
  isCustomized ? (
    <div className="input-group">
      <CustomInputGroupPrepend />
      {children}
    </div>
  ) : (
    <>{children}</>
  );

export const CustomInputGroupPrepend: FC = () => (
  <div className="input-group-text ">
    <i className="icon icon-sm text-info  icon-sm">fiber_manual_record</i>
  </div>
);
